/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Globe = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM7.01977 12.7505L2.52923 12.7508C2.87622 17.1891 6.2734 20.7709 10.6262 21.4014C8.52968 19.0894 7.19531 16.0736 7.01977 12.7505ZM21.4708 12.7508L16.9802 12.7506C16.8047 16.0739 15.4701 19.0899 13.3734 21.4019C17.7261 20.7714 21.1238 17.1895 21.4708 12.7508ZM15.4778 12.7503L8.52226 12.7508C8.69907 15.7267 9.92224 18.49 11.9354 20.6076L12 20.6727L12.0646 20.6078C14.0777 18.4904 15.3011 15.7266 15.4778 12.7503ZM10.6268 2.59791L10.4072 2.63294C6.15959 3.34998 2.86987 6.88611 2.52915 11.2502H7.01974C7.19514 7.9265 8.52977 4.91013 10.6268 2.59791ZM12 3.32565L11.9042 3.42513C9.90919 5.53873 8.69785 8.28946 8.52219 11.2502H15.4778C15.3012 8.27408 14.0781 5.51038 12.0653 3.39297L12 3.32565ZM13.3728 2.59846L13.5527 2.79968C15.5463 5.08441 16.81 8.02252 16.9803 11.2505L21.4708 11.2502C21.1243 6.81107 17.7264 3.22862 13.3728 2.59846Z"
                        fill={color}
                    />
                </svg>
        );
    };
